import { render, staticRenderFns } from "./ContratoPJ.vue?vue&type=template&id=d0529f7c"
import script from "./ContratoPJ.vue?vue&type=script&lang=js"
export * from "./ContratoPJ.vue?vue&type=script&lang=js"
import style0 from "./ContratoPJ.vue?vue&type=style&index=0&id=d0529f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports